import React from 'react'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {sanitizeHtml} from '@vio/core/src/_web/utils/dom'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {ContentKey} from './types'

const HtmlContentWrapper = styled('div')`
  ${cssTheme.typography.bodyM}
  text-align: start;

  & ul {
    padding-inline-start: ${cssTheme.layout.spacing.s600};
  }

  & ul li {
    margin-bottom: ${cssTheme.layout.spacing.s300};
  }

  & *:first-child {
    margin-top: 0;
  }

  & *:last-child {
    margin-bottom: 0;
  }
`

const HtmlContent = ({text}: {text: string}) => (
  <HtmlContentWrapper
    dir="auto"
    dangerouslySetInnerHTML={{
      __html: sanitizeHtml(text)
    }}
  />
)

interface Props {
  hotel: ContentHotel
  contentKey: ContentKey
}

/**
 * Renders any content property of a hotel
 * Return should always be wrapped in a single HTML node to allow layout with Stack
 */
export const HotelContent = ({hotel, contentKey}: Props) => {
  return {
    checkInSpInst: <HtmlContent text={hotel.checkInSpInst} />,
    checkInMinAge: (
      <Text>
        <FormattedMessageWrapper
          id="checkInMinAgeDescription"
          defaultMessage="Check-in must be done by someone who is at least {checkInMinAge} years old."
          values={{
            checkInMinAge: hotel.checkInMinAge
          }}
        />
      </Text>
    ),
    feesMnd: <HtmlContent text={hotel.feesMnd} />,
    feesOpt: <HtmlContent text={hotel.feesOpt} />,
    checkInInst: <HtmlContent text={hotel.checkInInst} />,
    policies: <HtmlContent text={hotel.policies} />,
    license: (
      <Box display="flex" flexDirection="column" gap="s200">
        <Text variant="titleM" tag="h3">
          <FormattedMessageWrapper
            id="businessDetails"
            defaultMessage="Business details"
          />
        </Text>
        <Text>
          <FormattedMessageWrapper
            id="propertyRegistrationNumber"
            defaultMessage="Property registration number {license}"
            values={{
              license: <bdi>{hotel.license}</bdi>
            }}
          />
        </Text>
      </Box>
    ),
    deposit: (
      <Box display="flex" flexDirection="column" gap="s200">
        <Text>
          <FormattedMessageWrapper
            id="depositOverlayDescription"
            defaultMessage="You'll be required to pay the following fully refundable deposit."
          />
        </Text>
        <HtmlContent text={hotel.deposit?.description} />
      </Box>
    )
  }[contentKey]
}
